import React from "react";
import { useI18n } from "@/i18n";

export const LegalPage = ({ namespace, sections, testId }) => {
  const { t } = useI18n();
  return (
    <section data-testid={testId} className="bg-[#FAFAFC]">
      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="mb-8 border-b border-slate-200 pb-6">
          <h1 className="font-serif text-3xl font-bold text-[#0F2C59] sm:text-4xl">
            {t(`${namespace}.title`)}
          </h1>
          <p className="mt-2 text-sm text-slate-500">{t(`${namespace}.updated`)}</p>
        </div>
        <article className="space-y-8">
          {sections.map((sec) => (
            <div key={sec}>
              <h2 className="font-serif text-xl font-semibold text-[#0F2C59]">
                {t(`${namespace}.${sec}_title`)}
              </h2>
              <p className="mt-3 text-base leading-relaxed text-slate-700">
                {t(`${namespace}.${sec}_body`)}
              </p>
            </div>
          ))}
        </article>
      </div>
    </section>
  );
};

export const PrivacyPolicy = () => (
  <LegalPage
    testId="privacy-page"
    namespace="privacy"
    sections={[
      "intro",
      "data",
      "purpose",
      "base",
      "sharing",
      "rights",
      "retention",
      "security",
      "changes",
    ]}
  />
);

export const Terms = () => (
  <LegalPage
    testId="terms-page"
    namespace="terms"
    sections={["s1", "s2", "s3", "s4", "s5", "s6", "s7", "s8", "s9"]}
  />
);

export default PrivacyPolicy;
